import useAuthUser from "./useAuthUser";

export default function useScmConfig() {
  const { authUser } = useAuthUser();
  return authUser?.organization.scmConfig;
}
